import { registerAllOpeners } from "@loot-os/react/openers";
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { queryClient } from "./queryClient";
import { TRPCProvider, trpcClient } from "./trpc";

// The Appearance preview shows every opener kind as the overlay does; each scene and its
// stylesheet load on first use.
registerAllOpeners();

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
        <App />
      </TRPCProvider>
    </QueryClientProvider>
  </StrictMode>,
);
